import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { LegalLayout } from "@/components/SiteFooter";
import { Seo } from "@/components/Seo";
import { api, errMsg } from "@/lib/api";

const MSGS = {
  milestones: "You're unsubscribed from milestone alert emails. You can turn them back on any time from your dashboard.",
  checklist: "You're unsubscribed from checklist reminder emails. You can turn them back on any time from your Retirement Checklist.",
  weekly: "You're unsubscribed from the weekly TSP recap email. You can turn it back on any time from the Content Hub.",
};

export default function Unsubscribe() {
  const [sp] = useSearchParams();
  const [msg, setMsg] = useState("Updating your preferences...");
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const type = MSGS[sp.get("type")] ? sp.get("type") : "weekly";
    api.post("/email/unsubscribe", { token: sp.get("token") || "", type })
      .then(() => setMsg(MSGS[type]))
      .catch((e) => setMsg(errMsg(e)));
  }, [sp]);
  return (
    <LegalLayout title="Email preferences">
      <Seo title="Unsubscribe" path="/unsubscribe" noindex />
      <p data-testid="unsubscribe-message">{msg}</p>
      <p><Link to="/learn">Back to the Content Hub</Link></p>
      <p>Questions: <a href="mailto:support@atkinsmedia.io" data-testid="unsubscribe-contact-email">support@atkinsmedia.io</a></p>
    </LegalLayout>
  );
}
